// extracted by mini-css-extract-plugin
export default {"description":"style_description__5rDIA","fade-in":"style_fade-in__AgBDa","top":"style_top__+bHu4","image":"style_image__Bio8F"};